import React from 'react';

export default function PaymentDoneIcon(props) {
  return (
    <svg
      width="40"
      height="41"
      viewBox="0 0 40 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g clipPath="url(#clip0_1652_5763)">
        <path
          d="M19.9997 3.83325C10.7997 3.83325 3.33301 11.2999 3.33301 20.4999C3.33301 29.6999 10.7997 37.1666 19.9997 37.1666C29.1997 37.1666 36.6663 29.6999 36.6663 20.4999C36.6663 11.2999 29.1997 3.83325 19.9997 3.83325ZM16.6663 28.8333L8.33301 20.4999L10.683 18.1499L16.6663 24.1166L29.3163 11.4666L31.6663 13.8333L16.6663 28.8333Z"
          fill="#EC4E0B"
        />
      </g>
      <defs>
        <clipPath id="clip0_1652_5763">
          <rect width="40" height="40" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
}
